import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewsletterContentFormatService {
  private readonly resourceType = new BehaviorSubject<string>('news');

  setContentFormat(format: string): void {
    const resourceType =
      format.toLowerCase() === 'stories' ? 'stories' : 'news';
    this.resourceType.next(resourceType);
  }

  getResourceType(): Observable<string> {
    return this.resourceType.asObservable();
  }

  getCurrentResourceType(): string {
    return this.resourceType.getValue();
  }
}
